const splideMV = '#splide-mv';
const splideMV_options = {
  type   : 'loop',
          autoplay: true,
          interval: 6000,
          perPage: 1,
          perMove: 1,
          rewind: false,
          updateOnMove: true,
          isNavigation: true,
          pagination: true,
          arrows: true,
          gap: 20,
          padding: '0',
          speed: 1500,
          focus  : 'center',
          breakpoints: {
            699: {
              perPage: 1,
            }
          },
}
if (document.querySelectorAll(splideMV).length > 0) {
  const mySplide = new Splide(splideMV, splideMV_options);
  mySplide.mount();
}